import { useNavigate } from 'react-router-dom';

import { Page } from '@/design-system/Layout';
import { vesselPath } from '@/router/routes';

import { VesselList } from './components/VesselList';
import { useManagedVesselSubscriptions } from './useManagedVesselSubscriptions';

/**
 * `/` — every vessel whose plan the signed-in user may manage, owned or captained, joined to
 * its subscription. A row drills down to `/:vesselId`, which is where a plan is changed; the
 * rows themselves only state which plan a vessel is on.
 */
export function VesselListPage() {
  const navigate = useNavigate();
  const { items, isLoading, isSubscriptionsPending, error } = useManagedVesselSubscriptions();

  return (
    <Page>
      <VesselList
        items={items}
        isLoading={isLoading}
        isSubscriptionsPending={isSubscriptionsPending}
        error={error}
        onOpen={(item) => navigate(vesselPath(item.vessel.id))}
      />
    </Page>
  );
}
